import _ from 'lodash';
import React, {FunctionComponent} from 'react';
import {Grid, makeStyles} from '@material-ui/core';
import {StoreIcon} from '@treez-ui/core/icons';
import {ProductStorePresenceAttributes} from '~/utils/ProductAPI';

interface Props {
    productStorePresence:
        | ProductStorePresenceAttributes[]
        | Partial<ProductStorePresenceAttributes>[];
    maxNumberOfStoresToShow: number;
}

export const StorePresenceCell: FunctionComponent<Props> = (props: Props) => {
    const {maxNumberOfStoresToShow, productStorePresence} = props;

    const useStyles = makeStyles({
        storeContainer: {
            display: 'flex',
            flexWrap: 'nowrap',
            height: '20px',
            justifyContent: 'center',
            overflow: 'hidden',
            width: '100%',
            margin: '10px',
        },
        storeIconContainer: {
            display: 'flex',
            height: '20px',
            width: '30px',
        },
        storeNameContainer: {
            alignItems: 'flex-end',
            display: 'flex',
            height: '20px',
            width: 'auto',
        },
        storeOverFlowContainer: {
            textAlign: 'center',
        },
        storePresenceContainer: {
            alignContent: 'center',
            display: 'flex',
            flexWrap: 'wrap',
            height: '100px',
            justifyContent: 'center',
            overflow: 'hidden',
            width: '100%',
        },
    });

    const {
        storeContainer,
        storeIconContainer,
        storeNameContainer,
        storeOverFlowContainer,
        storePresenceContainer,
    } = useStyles();

    const mapStoreCells = (
        productStorePresence:
            | ProductStorePresenceAttributes[]
            | Partial<ProductStorePresenceAttributes>[]
    ) => {
        return _.map(productStorePresence, (storePresence, idx) => {
            const {storeName} = storePresence;

            if (storeName && idx < maxNumberOfStoresToShow) {
                return (
                    <Grid className={storeContainer} key={storeName}>
                        <Grid className={storeIconContainer}>
                            <StoreIcon />
                        </Grid>
                        <Grid className={storeNameContainer}>{storeName}</Grid>
                    </Grid>
                );
            }
        });
    };

    const renderProductStorePresenceCell = () => {
        const numberOfStoresProductIsPresentIn = _.size(productStorePresence);
        switch (numberOfStoresProductIsPresentIn) {
            case 0:
                return <Grid />;
            case 1:
                return <Grid>{mapStoreCells(productStorePresence)}</Grid>;
            case 2:
                return <Grid>{mapStoreCells(productStorePresence)}</Grid>;
            default:
                return (
                    <Grid>
                        {mapStoreCells(productStorePresence)}
                        <Grid className={storeOverFlowContainer}>
                            {`+ ${numberOfStoresProductIsPresentIn - maxNumberOfStoresToShow} more`}
                        </Grid>
                    </Grid>
                );
        }
    };

    return <Grid className={storePresenceContainer}>{renderProductStorePresenceCell()}</Grid>;
};

export default StorePresenceCell;
